import { render, staticRenderFns } from "./LeadNotesPanel.vue?vue&type=template&id=3a22761b&scoped=true&"
import script from "./LeadNotesPanel.vue?vue&type=script&lang=js&"
export * from "./LeadNotesPanel.vue?vue&type=script&lang=js&"
import style0 from "./LeadNotesPanel.vue?vue&type=style&index=0&id=3a22761b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22761b",
  null
  
)

export default component.exports